module.exports = __webpack_public_path__ + "static/media/8081 Directors Meeting 6 Dec 2023 (New).5494e612.pdf";